import { sanitizeUrl } from 'javascripts/sanitizer';
import CustomField from '../../CustomField';

export class UrlCustomField extends CustomField {
  exampleContents() {
    return {
      link: 'aha.io',
      externalUrl: '#',
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.value) {
      return {
        link: customFieldValue.value,
        externalUrl: sanitizeUrl(customFieldValue.value),
      };
    }

    return {};
  }
}
